export enum IntroId {
  BLOOD = 'blood',
  HEALTHSCORE = 'healthscore',
  MY_LIFESTYLE = 'my-lifestyle',
  MY_HEALTH = 'my-health',
  MY_ANCESTRY = 'my-ancestry',
  PRS = 'prs',
  ORAL_MICROBIOME = 'oral-microbiome',
  ACTIVITY = 'activity',
  NUTRITION = 'nutrition',
}
